import { useMemo } from 'react'

import { NumericInputField } from '@/forms-legacy'
import { useGetDistanceUnitOfMeasure } from '@/hooks'

import { useTexts } from '../hooks/useTexts'

interface Props {
  metric: boolean
  currency: string
}

export function KmCost(props: Props) {
  const { metric, currency } = props
  const texts = useTexts()

  const unitOfMeasure = useGetDistanceUnitOfMeasure()

  const wrappedInputProps = useMemo(() => {
    return {
      step: 10,
      min: 0,
      useMetric: metric,
    }
  }, [metric])

  return (
    <NumericInputField
      name="kmCost"
      testid="kmCost"
      half
      label={texts.kmCost(`(${currency}/${unitOfMeasure})`, metric)}
      wrappedInputProps={wrappedInputProps}
    />
  )
}
